/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY3VzdG9tL2hlYWRlci9oZWFkZXIuY29tcG9uZW50Lmxlc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS92c3RzL3dvcmsvMS9zL2Vtci13ZWJhcHAvc3JjL2FwcC9jdXN0b20vaGVhZGVyL2hlYWRlci5jb21wb25lbnQubGVzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/custom/header/header.component.less.shim.ngstyle.ts